define.alias("ember-math-helpers/helpers/gcd", "settings/helpers/gcd");